exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".child-info{border:none;padding:0px;margin:0 25px 0 0;width:150px}.child-info img{display:block;margin:0 auto;width:60px;height:60px}.child-info .child-name{word-break:break-all;hyphens:auto}@media screen and (max-width: 767px){.child-info{width:80px}.child-info h4{font-size:13px;text-align:center;color:#333;word-wrap:break-word}.child-info img.mobile{width:40px;height:40px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/ChildInfo.scss
// module id = 660
// module chunks = 0